module.exports = function (_value) {
    if (isNaN(_value) || _value === null || _value === '') {
        return '--';
    }
    if (String(_value).indexOf('.') !== -1) {
    	return _value;
    }
    let arr = String(_value).split('').reverse();
    let new_arr = [];
    for (let i = 0, len = arr.length; i < len; i++) {
        if (i === 0 || i % 3 !== 0) {
            new_arr.push(arr[i]);
        } else {
            new_arr.push(',');
            new_arr.push(arr[i]);
        }
    }
    return new_arr.reverse().join('');
}


// WEBPACK FOOTER //
// ./src/views/dataPlatform/filters/data-format.js